import { useState } from "react";
import { getInteractionsByCalledId } from "@service/serviceOrder";
import { type InteractionCalled } from "@interfaces/ServiceOrder";
import { popupError } from "@service/zendesk";
import { AxiosError } from "axios";

export const useInteractions = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [interactions, setInteractions] = useState<InteractionCalled[]>([]);

  const handleInteractions = async (calledId: string) => {
    setLoading(true);

    try {
      const response = await getInteractionsByCalledId(calledId);

      if (response.status === 200) {
        setInteractions(response.data.data[0].interacoes);
      } else {
        popupError("Erro ao carregar interações. FAvor tente novamente mais tarde.", false);
      }
    } catch (err) {
      const error = err as AxiosError;
      if (error) {
        throw new Error("Erro ao buscar interações", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    handleInteractions,
    interactions,
    loading,
  };
};
